import type { AnyObject } from 'antd/es/_util/type';
import type { ExpandableConfig } from 'antd/es/table/interface';
import classNames from 'classnames';
import React from 'react';

type ExpandIconProps<RecordType> = Partial<
  Parameters<NonNullable<ExpandableConfig<RecordType>['expandIcon']>>[0]
>;

/**
 * antd renders this for every row once `expandable.expandIcon` is set, and omits the `expandable`
 * prop rather than passing false on rows that expand nothing — hence the bail, which is what makes
 * the icon safe as a global config.
 */
export const ExpandIcon = <RecordType extends AnyObject = AnyObject>({
  expanded,
  onExpand,
  record,
  expandable = false,
}: ExpandIconProps<RecordType>) => {
  if (!expandable) {
    return null;
  }

  const handleOnClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    onExpand?.(record as RecordType, event);
  };

  return (
    <i
      data-cy={record?.id ? `expand-${record.id}` : undefined}
      className={classNames('expanded-table__icon', {
        'fb-icon--arrow-up': expanded,
        'fb-icon--arrow-down': !expanded,
      })}
      onClick={handleOnClick}
    />
  );
};
